import { useImageUploadMutation } from './useImageUploadMutation';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentId } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import type { ChangeEvent } from 'react';
import { useRef } from 'react';
import type { DocumentImageLibraryPayload } from 'services/documents/DocumentRepository';
import { editorConfig } from 'components/editor/helpers/config';

export function useImageLibraryUploadHandler() {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { mutate: uploadImage } = useImageUploadMutation();
  const contentId = useAppSelector(selectContentId);

  const uploadFile = (files: File[]) => {
    const payload: DocumentImageLibraryPayload = {
      contentId,
      images: files,
      showSuccessNotification: true,
    };

    uploadImage(payload);
  };

  const handleClick = () => {
    if (fileInputRef?.current) {
      fileInputRef.current.click();
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event?.target?.files;

    if (!files?.length) {
      return;
    }

    uploadFile(Array.from(files));
    event.target.value = '';
  };

  return {
    fileInputRef,
    handleClick,
    handleChange,
    accept: editorConfig.acceptedImageTypes.join(','),
  };
}
